import { useSelector } from 'react-redux';
import { useGetProfileQuery } from 'services/profile';

import selectAccount from 'state/selectors/accounts/accountSelector';

export function usePwcCustomersAccountUuid() {
  const { account } = useSelector(selectAccount);
  const { data: profile } = useGetProfileQuery();

  return account.uuid || profile?.defaultAccountUuid || '';
}
